import { EventDrivenStore } from '@core/store/eventDrivenStore';
import constants from '@core/utils/constants';

class FavoritesStore extends EventDrivenStore {
  constructor() {
    const initialState = {
      restaurants: [],
      dishes: [],
      loading: false,
      error: null
    };
    super('favorites', initialState);
  }

  async setupEvents() {
    this.on(constants.EVENTS.USER.FAVORITES_LOAD, () => {
      this.state.loading = true;
      this.state.error = null;
    });

    this.on(constants.EVENTS.USER.FAVORITES_LOAD_SUCCESS, (data) => {
      this.state.restaurants = data.restaurants || [];
      this.state.dishes = data.dishes || [];
      this.state.loading = false;
      this.state.error = null;
    });

    this.on(constants.EVENTS.USER.FAVORITES_LOAD_ERROR, (error) => {
      this.state.loading = false;
      this.state.error = error;
    });

    this.on(constants.EVENTS.USER.FAVORITE_SUCCESS, ({ type, id, isFavorite }) => {
      // If we are removing a favorite, update our local list to keep it in sync
      if (!isFavorite) {
        if (type === 'restaurant') {
          this.state.restaurants = this.state.restaurants.filter(r => r.id !== id);
        } else if (type === 'dish') {
          this.state.dishes = this.state.dishes.filter(d => d.id !== id);
        }
      }
      // Note: If we are adding (isFavorite: true), we usually need to reload 
      // because we don't have the full object details here.
      // But adding typically happens from home/search, not from the favorites page itself.
    });
  }
}

export default FavoritesStore;
